import React from 'react';
import { PickItem } from '../pickPackTypes';
import styles from './PickItemRow.module.css';

interface PickItemRowProps {
  item: PickItem;
  onPickedChange: (id: string, value: string) => void;
  onCompleteToggle: (id: string) => void;
}

export const PickItemRow: React.FC<PickItemRowProps> = ({ item, onPickedChange, onCompleteToggle }) => {
  return (
    <div className={styles.row}>
      <div className={styles.productInfo}>
        <p className={styles.productName}>{item.productName}</p>
        <p className={styles.sku}>SKU: {item.sku}</p>
      </div>

      <div className={styles.locationSection}>
        <p className={styles.label}>Warehouse Location</p>
        <span className={styles.locationBadge}>{item.warehouseLocation}</span>
        <p className={styles.sku}>Lot: {item.lotNumber}</p>
      </div>

      <div className={styles.requiredSection}>
        <p className={styles.label}>Required</p>
        <p className={styles.requiredValue}>{item.requiredQty}</p>
      </div>

      <div className={styles.pickedSection}>
        <p className={styles.label}>Picked</p>
        <input
          type="text"
          className={styles.pickedInput}
          value={item.pickedQty}
          onChange={(e) => onPickedChange(item.id, e.target.value)}
          placeholder=""
        />
      </div>

      <div className={styles.completeSection}>
        <button
          className={item.completed ? styles.checkboxChecked : styles.checkbox}
          onClick={() => onCompleteToggle(item.id)}
          aria-label={item.completed ? 'Mark incomplete' : 'Mark complete'}
        >
          {item.completed && (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M3.5 8L6.5 11L12.5 5"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </button>
        <span className={styles.completeText}>Complete</span>
      </div>
    </div>
  );
};
